export const PANE_SIZE = 600;
export const BLUR_INITIAL = "blur(0px)";
export const BLUR_FINAL = "blur(0px)";
export const BACKGROUND_INITIAL = "rgba(0,0,0,0)";
export const BACKGROUND_FINAL = "rgba(0,0,0,0.25)";
export const TRANSITION = 0.3;
export const SWITCHER_SIZE = 400;
export const ARROW =
  "<svg width='12' height='6' viewBox='0 0 10 5' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10 5H0.926697L3.95208 1.63847C4.74227 0.760478 6.11722 0.754951 6.91445 1.62656L10 5Z' /></svg>";
